module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'InvoicePaymentTypeList'
      }
    }
  }, [_vm._v("Typy płatności")]), _vm._v("/Nowy typ płatności")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('InvoicePaymentTypeForm', {
    attrs: {
      "handle-submit": _vm.create,
      "values": _vm.item,
      "errors": _vm.violations
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9828ff4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoicepaymenttype/Create.vue
// module id = 845
// module chunks = 0